export default {
  items: [
    {
      title: true,
      name: 'Admin',
      class: '',
      wrapper: {
        element: '',
        attributes: {},
      },
    },
    {
      name: 'Bedrijven',
      url: '/admin/bedrijven',
      icon: 'icon-home',
    },
    {
      name: 'Klanten',
      url: '/admin/klanten',
      icon: 'icon-people',
    },
    {
      name: 'Aanvragen',
      url: '/admin/aanvragen',
      icon: 'icon-share-alt',
    },
    {
      name: 'FAQ',
      url: '/admin/faq',
      icon: 'icon-list',
      attributes: {
        disabled: true,
      },
    },
    {
      title: true,
      name: 'Beheer',
      class: '',
      wrapper: {
        element: '',
        attributes: {},
      },
    },
    {
      name: 'Glossary',
      url: '/admin/glossary',
      icon: 'icon-book-open',
    },
    {
      name: 'Gebruikers',
      url: '/admin/gebruikers',
      icon: 'icon-user',
    },
  ],
};
